import { render, staticRenderFns } from "./LazyCustomTable.vue?vue&type=template&id=6c0d56da&scoped=true&"
import script from "./LazyCustomTable.vue?vue&type=script&lang=js&"
export * from "./LazyCustomTable.vue?vue&type=script&lang=js&"
import style0 from "./LazyCustomTable.vue?vue&type=style&index=0&id=6c0d56da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d56da",
  null
  
)

export default component.exports